
import { defineComponent, onMounted, ref, inject, provide } from 'vue'
import { useRoute } from 'vue-router';
//components
import DialogResumenF1 from "./forms/DialogResumenF1.vue"
import DialogResumenF2 from "./forms/DialogResumenF2.vue"
//services
import eventService from "@/core/services/EventService";
import { errManager } from "@/core/config/Tools";
import { useI18n } from "vue-i18n/index";
import { useRouter } from 'vue-router';
import moment from 'moment';

export default defineComponent({
    name: "acrd-forms",
    components: {
        DialogResumenF1, DialogResumenF2
    },
    setup() {
        const { t } = useI18n();
        const route = useRoute();
        const router = useRouter();
        const { id } = route.params
        const evento = inject<any>("evento")
        const loader = ref(false)
        const dialogForm = ref(false)
        const listForms = ref<any>([])
        const itemForm = ref<any>({})
        const dialogListClubs = ref(false)
        const dialogResF2 = ref(false)

        //provides
        provide("dialogListClubs", dialogListClubs)
        provide("dialogResF2", dialogResF2)

        const getForms = async () => {
            loader.value = true
            listForms.value = []
            eventService.getForms(id)
                .then((res) => {
                    listForms.value = res.data
                    loader.value = false
                }).catch(({ response }) => {
                    loader.value = false
                    errManager(response)
                })
        }

        // Función para formatear las fechas
        const formatDate = (date: string) => {
            return moment(date).locale('es').format('D [de] MMMM [del] YYYY');
        };

        const openDialogForm = (data) => {
            itemForm.value = data

            if(data.idform == 1)
                dialogListClubs.value = true
            if(data.idform == 2)
                dialogResF2.value = true

        }

        const modalClosed = () => {
            itemForm.value = null
            getForms()
        }

        onMounted(() => {
            getForms()
        })

        return {
            t,
            id,
            evento,
            loader,
            itemForm,
            dialogForm,
            listForms,
            dialogListClubs,
            dialogResF2,

            //methods
            getForms,
            //openDialogForm,
            formatDate,
            openDialogForm,
            modalClosed
        }

    },
})
